import React from 'react'
import styles from './ButtonLoader.module.scss'

const ButtonLoader = () => {
  return (
    <div className={styles['lds-spinner']}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default ButtonLoader
